'use client';

import { useEffect, useState } from "react";
import { Contact, SlideOutContact } from "@/app/lib/generated/graphql-types";
import { loadContactFlyoutContent } from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/data-access/preload";
import FlyoutWrapper from "@/app/features/sites/header/ui/desktop/flyout-info/FlyoutWrapper";
import { Stack } from "@mui/system";
import FlyoutHeaderTypography
    from "@/app/features/sites/header/ui/desktop/flyout-info/FlyoutHeaderTypography";
import { Markdown } from "@/app/features/shared/markdown/Markdown";
import { Button, Divider } from "@mui/material";
import { Group } from "@mui/icons-material";
import Link from "next/link";
import PhoneButton from "@/app/__to_be_integrated/_____components/_NEW/contact/buttons/PhoneButton";
import EmailButton from "@/app/__to_be_integrated/_____components/_NEW/contact/buttons/EmailButton";
import ErrorBox from "@/app/__to_be_integrated/_____components/_NEW/ErrorBox";
import useIsDesktop from "@/hooks/useDesktop";

export default function ContactFlyoutInfo() {
    const isDesktop = useIsDesktop();
    const [content, setContent] = useState<{ slideOutContact: SlideOutContact, contact: Contact}>();
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        (async () => {
            const { data, error } = await loadContactFlyoutContent();
            if (error || !data) {
                console.error('Error loading contact flyout content:', error);
                setError('Fehler beim Laden der Inhalte. Bitte versuchen Sie es später erneut.');
                return;
            }

            setContent(data);
        })()
    }, []);

    if (error) return <ErrorBox error={error} />
    if (content === undefined) return null;

    return (
        <FlyoutWrapper
            backgroundImage={content.slideOutContact.image}
            contentSide="right"
            slots={{
                paper: {
                    sx: {
                        ...isDesktop
                            ? {
                                width: '40vw',
                            }
                            : {
                            }
                    }
                }
            }}
        >
            <Stack spacing={4}>
                <Stack spacing={4}>
                    <FlyoutHeaderTypography>
                        {content.slideOutContact.title}
                    </FlyoutHeaderTypography>
                    <Markdown value={content.slideOutContact.description}/>
                    <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                        <EmailButton email={content.contact.emailAddress} />
                        <PhoneButton phone={content.contact.phone} />
                    </Stack>
                </Stack>
                <Divider/>
                <Stack spacing={3}>
                    <Markdown value={content.slideOutContact.teamDescription}/>
                    <Link
                        href="/team"
                        passHref
                        prefetch
                    >
                        <Button
                            variant="outlined"
                            className="w-full md:w-auto"
                            startIcon={<Group />}
                        >
                            Zum Team
                        </Button>
                    </Link>
                </Stack>
            </Stack>
        </FlyoutWrapper>
    )
}
